module.exports = __webpack_public_path__ + "static/media/hotel.c29d8215.jpg";